exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.button-div[data-v-0b38b6bf] {\n  text-align: right;\n}\n", "", {"version":3,"sources":["/Users/fabianspring/Documents/projects/omyfu/omyfu-spa-vue/src/components/funeral/music/MusicAddComponent.vue"],"names":[],"mappings":";AAkEA;EACI,kBAAiB;CACpB","file":"MusicAddComponent.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.button-div {\n    text-align: right;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0b38b6bf","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/funeral/music/MusicAddComponent.vue
// module id = pCBH
// module chunks = 1